module.exports = __webpack_public_path__ + "static/media/sensor.6ac2c3f6.svg";